import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-view.printer',
  templateUrl: './view-printer.component.html',
  styleUrls: ['./view-printer.component.scss'],
})
export class ViewPrintJobComponent implements OnInit {

  constructor() { }

  ngOnInit() {}

}
